<template>
  <FormLabel :required="required" :text="text" :error="(!disabled) ? (forceError || error) : ''">
    <input class="aoformfield" :placeholder="placeholder" autocomplete="off" ref="input" :type="type" inputmode="numeric" :readonly="disabled || $store.getters.loading" :name="name" v-maska :data-maska="mask" v-model="val" @focus="fillStartMask" @blur="filledCheck">
  </FormLabel>
</template>

<script>
import FormLabel from '../FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { vMaska } from 'maska'

export default {
  components: { FormLabel },
  mixins: [FormField],
  directives: { maska: vMaska },
  props: {
    required: { type: Boolean, default: false },
    name: { type: String, required: true },
    modelValue: { type: String, default: '' },
    text: { type: String, required: true },
    type: { type: String, default: 'text' },
    placeholder: { type: String },
    mask: { type: String },
    forceError: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    validation: { type: Function, default: () => '' },
    filled: { type: Function, default: (v) => v ? true : false }
  },
  data: () => ({
    error: '',
    AsyncFunction: (async () => { }).constructor
  }),
  computed: {
    val: {
      get() { return this.modelValue },
      set(value) { this.$emit('update:modelValue', value) },
    },
  },
  methods: {
    fillStartMask() {
      if (this.mask && this.val.length < this.mask.match(/^[^#]*(?=#)/)[0].length) {
        this.val = this.mask.match(/^[^#]*(?=#)/)[0]
      }
    },
    filledCheck() {
      if (this.modelValue == '') return this.error = ""
      if (!this.filled(this.modelValue)) {
        this.error = "Заполните поле"
      }
    }
  },
  watch: {
    async modelValue(newVal) {
      if (this.validation instanceof this.AsyncFunction === true)
        this.error = await this.validation(newVal)
      else
        this.error = this.validation(newVal)
      this.filledCheck()
      /*
      if (newVal && !this.error)
        this.$store.dispatch('ad_storage/callAction', this.name)*/
    }
  }
}
</script>

<style lang="sass">

</style>